import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromMenu from '../../store/reducers/menu.reducer';
import * as fromSelectors from '../../store/selectors';
import { Observable } from 'rxjs';
import { Avatar } from '../../models/avatar.model';
import { AuthService } from '../../../login/services/auth.service';
import * as fromAuth from '../../../store';
import { Role } from 'src/app/shared/models/role';
import { ParametersService } from '../../../core/services/parameters.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})

export class MenuComponent implements OnInit {

  avatar$: Observable<Avatar>;
  navbarOpen = false;
  currentLanguage: string;

  currentRole: Role;

  constructor(
    private store: Store<fromMenu.MenuState>,
    private authService: AuthService,
    private storeAuth: Store<fromAuth.AuthState>,
    private parametersService: ParametersService,
    private translate: TranslateService
  ) {
    this.currentLanguage = localStorage.getItem('lang') || 'es';
    this.translate.use(this.currentLanguage);
  }

  ngOnInit() {
    this.avatar$ = this.store.pipe(
      select(fromSelectors.getUser)
    );
    this.storeAuth.pipe(
      select(fromAuth.selectSessionCurrentrole)).subscribe(
        currentRole => this.currentRole = currentRole
      );
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  logout() {
    this.storeAuth.dispatch(fromAuth.logout());
    this.authService.logout();
  }

  changeLanguage(language) {
    this.currentLanguage = language;
    this.translate.use(language);
    localStorage.setItem('lang', language);
    window.location.reload();
  }

  get logo() {
    const country = this.parametersService.country;
    if (country.code !== '') {
      return `assets/img/${country.code}.svg`;
    }
  }

}
